<template lang="pug">
liondesk-dialog-v2(
  v-model="value"
  hide-ok-button
  hide-cancel-button
  close-button-icon="$vuetify.icons.cancel-outline"
)
  template(slot="body")
    v-card.body
      v-layout.header.mb-3.py-2.px-3(wrap row justify-center)
        v-flex(xs12)
          span Upgrade your plan to sync your emails
      v-layout.px-3(wrap row justify-center)
        v-flex.mb-4(xs12)
          v-layout(wrap row)
            v-flex(shrink)
              span.sub-title All email records in one place.
            v-flex(shrink)
              v-layout.pl-2
                v-flex.mr-2( v-for=" (icon, index) in providersIcons" shrink)
                  v-img(
                    v-if="index < 3"
                    :src="icon"
                    height="26"
                    width="26"
                  )
                  span.others-text(v-else) + Others
        v-flex.mb-4(xs12)
          div
            | Send and receive emails in LionDesk by syncing up to 2 email accounts.
            | We support all email accounts (Gmail, Outlook, Office365, or other third-party accounts)
            | except for encrypted email accounts.
        v-flex.mb-4(xs12)
          span Upgrade your plan for:
          ul
            li
              span Syncing your emails (Included in both CRM and CRM premier plans)
            li
              span 7500 Emails per Month including Video
            li
              span Mass Emailing
            li
              span Pre-Built Marketing Campaigns
            li
              span And more!
        v-flex.text-xs-center(xs12)
          v-btn.action(color="primary" :href="redirectURL") Upgrade my plan
        v-flex.text-xs-center.mb-2(xs12)
          v-btn.action(flat color="gray" @click="handleNoThanks") No thanks
</template>

<script>
import LiondeskDialogV2 from '@/Core/components/LiondeskDialogV2';
import PROVIDERS from '@/Email-Integrations/config/services';

export default {
  name: 'upgrade-to-email-connection',
  components: {
    LiondeskDialogV2,
  },
  data() {
    return {
      providersIcons: PROVIDERS.map(provider => provider.image),
    };
  },
  props: {
    value: Boolean,
  },
  methods: {
    handleNoThanks() {
      this.$emit('input', false);
    },
  },
  computed: {
    redirectURL() {
      const redirect = encodeURIComponent(`${window.location.origin}/email-integrations?open-drawer=true`);
      return `${process.env.VUE_APP_ACCOUNTS_APP_URL}/settings?redirect_url=${redirect}`;
    },
  },
};
</script>

<style lang="scss" scoped>

//see crm/www/src/Core/components/LiondeskDialogV2.vue dialog-container class
.body {
  margin: -30px -30px -54px -30px;
  text-align: left;
}
.sub-title {
  font-size: 20px;
  font-weight: 700;
}
.others-text {
  font-size: 20px;
}
.action {
  text-decoration: underline;
}
.header {
  background-color: #93bde5;
  /deep/ span {
    color: white;
    font-size: 16px;
  }
}
</style>